import {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Pencil} from '../../../../assets/svgs/icons';
import useAgentSessionStore from '../../store/agentSessionStore';
import {updateSessionTitle as updateSessionTitleApi} from '../../services/agentSessionService';
import styles from './styles.module.css';

export default function ChatHeader() {
  const {t} = useTranslation();
  const {sessions, activeSessionId, updateSessionTitle} = useAgentSessionStore();
  const activeSession = sessions.find((s) => s.uuid === activeSessionId);
  const displayTitle =
    activeSession?.title || t('campaignChat.newConversation');
  const [editingName, setEditingName] = useState(displayTitle);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setEditingName(displayTitle);
    }
  }, [displayTitle, isEditing]);

  const startEditing = () => {
    setEditingName(displayTitle);
    setIsEditing(true);
  };

  const commitTitle = async () => {
    setIsEditing(false);
    const trimmed = editingName.trim();
    if (!trimmed || trimmed === displayTitle || !activeSessionId) return;
    updateSessionTitle(activeSessionId, trimmed);
    try {
      await updateSessionTitleApi(activeSessionId, trimmed);
    } catch {
      updateSessionTitle(activeSessionId, displayTitle);
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerStatus}>
        <div className={styles.statusIndicator}>
          <div className={`${styles.statusDot} ${styles.statusDotConnected}`} />
        </div>
        <span className={styles.statusText}>
          {t('campaignChat.header.online')}
        </span>
      </div>
      <div className={styles.headerSeparator} />
      <div
        className={`${styles.campaignNameContainer} ${
          isEditing ? styles.campaignNameContainerEditing : ''
        }`}
      >
        {isEditing ? (
          <input
            type="text"
            className={styles.campaignNameInput}
            value={editingName}
            onChange={(e) => setEditingName(e.target.value)}
            onBlur={commitTitle}
            onKeyDown={(e) => {
              if (e.key === 'Enter') commitTitle();
            }}
            autoFocus
          />
        ) : (
          <span className={styles.campaignNameText} onClick={startEditing}>
            {displayTitle}
          </span>
        )}
        <button
          type="button"
          className={styles.editButton}
          onClick={startEditing}
          aria-label={t('chatsocket.chat.edit_overlay')}
        >
          <Pencil color="#BC00EE" size="14" />
        </button>
      </div>
    </div>
  );
}
